import { LoadingScreen } from '@/shared/components'
import MissingResourcesAlert from '@/components/MissingResourcesAlert'
import useI18n from '@/shared/hooks/useI18n'
import { PageSection, Partnership, Table, TableColumnHeader, TableRow } from '@/common'
import PendingImporterRow from './components/PendingImporterRow'
import ConnectedImporterRow from './components/ConnectedImporterRow'

export default function ConnectedImportersPage({
  createdOrPendingOutgoingInvitations,
  acceptedPartnerships,
  isLoading
}: {
  createdOrPendingOutgoingInvitations: Partnership[]
  acceptedPartnerships: Partnership[]
  isLoading: boolean
}) {
  const { t } = useI18n()

  const hasPendingOutgoingInvitations = createdOrPendingOutgoingInvitations.length > 0
  const hasAcceptedPartnerships = acceptedPartnerships.length > 0

  return (
    <>
      <div>
        <PageSection title={t('importers:importersList.outgoingInvitations.title')}>
          {isLoading && <LoadingScreen />}
          {!isLoading && !hasPendingOutgoingInvitations && (
            <MissingResourcesAlert
              title={t('importers:importersList.outgoingInvitations.noOutgoingInvitations.title')}
              description={t(
                'importers:importersList.outgoingInvitations.noOutgoingInvitations.description'
              )}
            />
          )}
          {!isLoading && hasPendingOutgoingInvitations && (
            <div className="overflow-x-auto">
              <Table className="table-fixed">
                <thead>
                  <TableRow>
                    <TableColumnHeader className="w-72">
                      {t('importers:importersList.outgoingInvitations.table.importerName')}
                    </TableColumnHeader>
                    <TableColumnHeader className="w-72">
                      {t('importers:importersList.outgoingInvitations.table.createdAt')}
                    </TableColumnHeader>
                    <TableColumnHeader className="w-72">
                      {t('importers:importersList.outgoingInvitations.table.invitationSentAt')}
                    </TableColumnHeader>
                    <TableColumnHeader className="w-72">
                      {t('importers:importersList.outgoingInvitations.table.invitedVia')}
                    </TableColumnHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {createdOrPendingOutgoingInvitations?.map(partnership => {
                    return <PendingImporterRow key={partnership.id} partnership={partnership} />
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </PageSection>
        <PageSection title={t('importers:importersList.connectedImporters.title')}>
          <div>
            {isLoading && <LoadingScreen />}
            {!isLoading && !hasAcceptedPartnerships && (
              <MissingResourcesAlert
                title={t('importers:importersList.connectedImporters.noImporters.title')}
                description={t(
                  'importers:importersList.connectedImporters.noImporters.description'
                )}
              />
            )}
            {!isLoading && hasAcceptedPartnerships && (
              <Table className="table-fixed">
                <thead>
                  <TableRow>
                    <TableColumnHeader>
                      {t('importers:importersList.connectedImporters.table.importerName')}
                    </TableColumnHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {acceptedPartnerships.map(partnership => {
                    return <ConnectedImporterRow key={partnership.id} partnership={partnership} />
                  })}
                </tbody>
              </Table>
            )}
          </div>
        </PageSection>
      </div>
    </>
  )
}
